import axios from '@/requests';
import { Clipboard } from '@/store/modules/clipboard/types';

export interface GetClipboardReq {
    projId: string,
    uid: string,
    pageNum: number,
    pageSize: number,
}

export interface GetClipbordByTime extends GetClipboardReq {
    time: string,
}

export const ClipboardAPI = {
    async getClipboardListByUid(getClipboardReq: GetClipboardReq) {
        try {
            const res = await axios.get<Clipboard[]>('/Clipboard/getClipboardListByUid', getClipboardReq);
            return res;
        } catch (err) {
            return Promise.reject(err);
        }

    },
    async getTimeLineByUid(projId: string, uid: string) {
        try {
            const res = await axios.get<Clipboard[]>('/Clipboard/getTimeLineByUid', { projId: projId, uid: uid });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }

    },
    async getClipboardListByUidAndTime(GetClipbordByTime: GetClipbordByTime) {
        try {
            const res = await axios.get<Clipboard[]>('/Clipboard/getClipboardListByUidAndTime', GetClipbordByTime);
            return res;
        } catch (err) {
            return Promise.reject(err);
        }

    },
}